export default "__VITE_ASSET__be8c31f9__"